import React from 'react';

import { Wrapper } from './styles';
import { Heading } from '../Typography/Heading';
import { Paragraph } from '../Typography/Paragraph';

export interface Props {
  title: string;
  text?: string;
}

const NoResultFound = ({ title, text }: Props) => {
  return (
    <Wrapper>
      <Heading level={4}>{title}</Heading>
      {text && <Paragraph level={5}>{text}</Paragraph>}
    </Wrapper>
  );
};

export default NoResultFound;
